import Button, { ButtonProps } from ".";

const SmallButton = (props: ButtonProps) => (
  <Button h="2.25rem" px={8} fz="0.875rem" lh={1.429} {...props} />
);

export default SmallButton;
